module.exports = __webpack_public_path__ + "img/kylin.26c3135e.png";